// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrWarningDto
 */
export interface IOcrWarningDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrWarningDto
     */
    warning?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IOcrWarningDto
     */
    fields?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IOcrWarningDto
     */
    type?: IOcrWarningDtoTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IOcrWarningDtoTypeEnum {
    MISSING = 'MISSING',
    WRONG_SERVICE = 'WRONG_SERVICE',
    OUT_OF_COVERAGE_DATE = 'OUT_OF_COVERAGE_DATE',
    RETAIL_OUT_OF_COVERAGE_DATE = 'RETAIL_OUT_OF_COVERAGE_DATE',
    DUPLICATE_RECEIPT = 'DUPLICATE_RECEIPT'
}


/**
 * Check if a given object implements the IOcrWarningDto interface.
 */
export function instanceOfIOcrWarningDto(value: object): value is IOcrWarningDto {
    return true;
}

export function IOcrWarningDtoFromJSON(json: any): IOcrWarningDto {
    return IOcrWarningDtoFromJSONTyped(json, false);
}

export function IOcrWarningDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrWarningDto {
    if (json == null) {
        return json;
    }
    return {
        
        'warning': json['warning'] == null ? undefined : json['warning'],
        'fields': json['fields'] == null ? undefined : json['fields'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function IOcrWarningDtoToJSON(json: any): IOcrWarningDto {
    return IOcrWarningDtoToJSONTyped(json, false);
}

export function IOcrWarningDtoToJSONTyped(value?: IOcrWarningDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warning': value['warning'],
        'fields': value['fields'],
        'type': value['type'],
    };
}

